import { ProcessedMessage } from '../../api/Altinn';
import { UserActions } from './action';

export interface UserState {
    funFacts: any;
    scoreData: any;
    profileData: any;
    requestID: string | null;
    mainCounter: boolean;
    processedMessages: ProcessedMessage[];
    shortcodes: Record<string, string> | null;
    requestKey: string;
}

export const defaultUserState: UserState = {
    funFacts: null,
    mainCounter: false,
    processedMessages: [],
    profileData: null,
    requestID: null,
    requestKey: '',
    scoreData: null,
    shortcodes: null,
};

export const userReducer = (
    state: UserState = defaultUserState,
    action: UserActions,
): UserState => {
    switch (action.type) {
        case 'ADD_USER_DATA':
            return {
                ...state,
                ...{
                    [action.schema]: action.payload,
                },
            };

        case 'CLEAR_USER_DATA':
            return defaultUserState;
        default:
            return state;
    }
};
